import { initFlowbite } from 'flowbite'

window.sidekick = {
    initializeFlowbite: initFlowbite,
};